/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Noversions1Inputs */

const zh_course_noversions1 = /** @type {(inputs: Course_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无可用资源`)
};

const en_course_noversions1 = /** @type {(inputs: Course_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resources available`)
};

const es_course_noversions1 = /** @type {(inputs: Course_Noversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay recursos disponibles`)
};

/**
* | output |
* | --- |
* | "No resources available" |
*
* @param {Course_Noversions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_noversions1 = /** @type {((inputs?: Course_Noversions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Noversions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_noversions1(inputs)
	if (locale === "en") return en_course_noversions1(inputs)
	return es_course_noversions1(inputs)
});
export { course_noversions1 as "course_noVersions" }